import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useFetch } from '@reveni-io/reveni-ui'

import returnsServices from '@/returns/services/services'

import { modalModes } from './constants'

const useBulkOnHold = ({ selectedTransactionIds, setToastInfo, refetchTransactions, returnPortalId }) => {
  const { t } = useTranslation()
  const [showBulkOnHoldTransactionsModal, setShowBulkOnHoldTransactionsModal] = useState(false)
  const [bulkOnHoldTransactionsModalMode, setBulkOnHoldTransactionsModalMode] = useState(null)
  const { loading: approvingBulkOnHoldTransactions, fetchData: fetchApprove } = useFetch(
    returnsServices.approveOnHoldTransactions,
    {
      doInitialRequest: false,
    }
  )
  const { loading: decliningBulkOnHoldTransactions, fetchData: fetchDecline } = useFetch(
    returnsServices.declineOnHoldTransactions,
    {
      doInitialRequest: false,
    }
  )

  const onApproveOnHoldTransactions = () => {
    setBulkOnHoldTransactionsModalMode(modalModes.approve)
    setShowBulkOnHoldTransactionsModal(true)
  }

  const onDeclineOnHoldTransactions = () => {
    setBulkOnHoldTransactionsModalMode(modalModes.decline)
    setShowBulkOnHoldTransactionsModal(true)
  }

  const closeBulkOnHoldTransactionsModal = () => {
    setShowBulkOnHoldTransactionsModal(false)
    setBulkOnHoldTransactionsModalMode(null)
  }

  const approveOnHoldTransactions = async () => {
    try {
      await fetchApprove({ transactionIds: selectedTransactionIds, params: { portal_id: returnPortalId } })
      refetchTransactions()
      setToastInfo({ show: true, type: 'success', message: t('Transacciones aprobadas correctamente') })
      closeBulkOnHoldTransactionsModal()
    } catch (error) {
      setToastInfo({ show: true, type: 'error', message: error?.errorMessage })
    }
  }

  const declineOnHoldTransactions = async () => {
    try {
      await fetchDecline({ transactionIds: selectedTransactionIds, params: { portal_id: returnPortalId } })
      refetchTransactions()
      setToastInfo({ show: true, type: 'success', message: t('Transacciones rechazadas correctamente') })
      closeBulkOnHoldTransactionsModal()
    } catch (error) {
      setToastInfo({ show: true, type: 'error', message: error?.errorMessage })
    }
  }

  return {
    approvingBulkOnHoldTransactions,
    decliningBulkOnHoldTransactions,
    onApproveOnHoldTransactions,
    onDeclineOnHoldTransactions,
    showBulkOnHoldTransactionsModal,
    closeBulkOnHoldTransactionsModal,
    bulkOnHoldTransactionsModalMode,
    approveOnHoldTransactions,
    declineOnHoldTransactions,
  }
}

export default useBulkOnHold
